import { Image } from '@findy-code/yuffie/ui/image';

import styles from './company-images.component.module.scss';
import { getJobTypeName } from './job-type-name';

type Props = {
  images: {
    url: string;
  }[];
  companyName?: string;
  jobTypeName?: string | null;
  managementJobTypeName?: string | null;
};

export const CompanyImages = ({
  images,
  companyName,
  jobTypeName,
  managementJobTypeName,
}: Props) => {
  const alt = `${getJobTypeName(jobTypeName, managementJobTypeName)}${
    (jobTypeName || managementJobTypeName) && companyName ? ' | ' : ''
  }${companyName ? `${companyName}` : ''}`;
  return (
    <ul className={styles.companyImageList}>
      {images.map((image, index) => (
        <li key={index}>
          <Image
            fill
            alt={alt}
            sizes="328px"
            src={image.url}
            style={{ objectFit: 'cover' }}
          />
        </li>
      ))}
    </ul>
  );
};
